module.exports = __webpack_public_path__ + "img/Cycling-Mountain-Bike.a7899fa6.png";